import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tariff-section" }
const _hoisted_2 = { class: "pricing-item" }
const _hoisted_3 = { class: "pricing-value" }
const _hoisted_4 = { class: "amount" }
const _hoisted_5 = {
  key: 0,
  class: "indicator"
}
const _hoisted_6 = { class: "pricing-group" }
const _hoisted_7 = { class: "pricing-item" }
const _hoisted_8 = { class: "pricing-value" }
const _hoisted_9 = { class: "amount" }
const _hoisted_10 = {
  key: 0,
  class: "indicator"
}
const _hoisted_11 = { class: "pricing-item" }
const _hoisted_12 = { class: "pricing-value" }
const _hoisted_13 = { class: "amount" }
const _hoisted_14 = {
  key: 0,
  class: "indicator"
}
const _hoisted_15 = { class: "pricing-item" }
const _hoisted_16 = { class: "pricing-label" }
const _hoisted_17 = { class: "pricing-value" }
const _hoisted_18 = { class: "amount" }
const _hoisted_19 = {
  key: 0,
  class: "indicator"
}
const _hoisted_20 = { class: "pricing-item" }
const _hoisted_21 = { class: "pricing-value" }
const _hoisted_22 = { class: "amount" }
const _hoisted_23 = {
  key: 0,
  class: "indicator"
}
const _hoisted_24 = { class: "pricing-group" }
const _hoisted_25 = { class: "pricing-item" }
const _hoisted_26 = { class: "pricing-label" }
const _hoisted_27 = { class: "pricing-value" }
const _hoisted_28 = { class: "amount" }
const _hoisted_29 = {
  key: 0,
  class: "indicator"
}
const _hoisted_30 = { class: "pricing-item" }
const _hoisted_31 = { class: "pricing-label" }
const _hoisted_32 = { class: "pricing-value" }
const _hoisted_33 = { class: "amount" }
const _hoisted_34 = {
  key: 0,
  class: "indicator"
}
const _hoisted_35 = { class: "pricing-item" }
const _hoisted_36 = { class: "pricing-value" }
const _hoisted_37 = { class: "amount" }
const _hoisted_38 = {
  key: 0,
  class: "indicator"
}

import { EvTripExtended } from '@/models/evTrip'


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceBreakDownSection',
  props: {
    trip: {},
    to_calculate_parameter_list: {}
  },
  setup(__props: any) {

const props = __props

// Check if a tariff parameter was used in the trip calculation
const isTariffUsed = (paramName: string): boolean => {
  if (!props.to_calculate_parameter_list) {
    return false
  }

  // Handle both array format and string format
  if (Array.isArray(props.to_calculate_parameter_list)) {
    const result = props.to_calculate_parameter_list.includes(paramName)
    return result
  }

  // If it's a string (JSON), parse it
  if (typeof props.to_calculate_parameter_list === 'string') {
    try {
      const parsed = JSON.parse(props.to_calculate_parameter_list)
      const result = Array.isArray(parsed) && parsed.includes(paramName)
      return result
    } catch (err) {
      console.error('❌ Failed to parse JSON:', err)
      return false
    }
  }

  return false
}

// Format price function to handle null/undefined values and convert from kopecks
const formatPrice = (amount: number | string | null | undefined): string => {
  if (amount === null || amount === undefined || amount === '') return '0.00'

  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  if (isNaN(numAmount)) return '0.00'

  // Convert from kopecks to AZN (divide by 100)
  return numAmount.toFixed(2)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "section-title" }, "TARIFF", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "pricing-label" }, "Reserve", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(formatPrice(props.trip?.deposit_amount)) + " ₼ / min", 1),
        (isTariffUsed('deposit_amount'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "•"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "pricing-subtitle" }, "Minute package", -1)),
      _createElementVNode("div", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "pricing-label" }, "Start price", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(formatPrice(props.trip?.start_price)) + " ₼", 1),
          (isTariffUsed('start_price'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "•"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "pricing-label" }, "Pause", -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(formatPrice(props.trip?.pause_price_ev)) + " ₼ / min", 1),
          (isTariffUsed('pause_price_ev'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "•"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, "Minute Package (limit " + _toDisplayString(props.trip?.ev_car_profile?.max_distance_per_minute_tariff) + " km)", 1),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(formatPrice(props.trip?.price_per_minute_up_to_100_km_ev)) + " ₼/min", 1),
          (isTariffUsed('price_per_minute_up_to_100_km_ev'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "•"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "pricing-label" }, "Extra km price", -1)),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(formatPrice(props.trip?.price_per_minute_above_100_km_ev)) + " ₼/min", 1),
          (isTariffUsed('price_per_minute_above_100_km_ev'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "•"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "pricing-subtitle" }, "Hourly package", -1)),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("span", _hoisted_26, "Hourly Package (limit " + _toDisplayString(props.trip?.ev_car_profile?.max_distance_per_hour_tariff) + " km)", 1),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(formatPrice(props.trip?.price_per_hour_up_to_100_km_ev)) + " ₼", 1),
          (isTariffUsed('price_per_hour_up_to_100_km_ev'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "•"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("span", _hoisted_31, "Minute Package (limit " + _toDisplayString(props.trip?.ev_car_profile?.max_distance_per_hour_tariff) + " km)", 1),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString(formatPrice(props.trip?.price_per_minute_up_to_100_km_ev)) + " ₼/min", 1),
          (isTariffUsed('price_per_minute_up_to_100_km_ev'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_34, "•"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "pricing-label" }, "Extra km price", -1)),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", _hoisted_37, _toDisplayString(formatPrice(props.trip?.price_per_minute_above_100_km_ev)) + " ₼/min", 1),
          (isTariffUsed('price_per_minute_above_100_km_ev'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "•"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})